export default __webpack_public_path__ + "static/media/506.f04b3f54.png";